/**
 * CriHeader component
 * Lightweight header for CRI / Wan-Wan / Art template pages.
 * Renders the Emergency bar — offer banner is handled elsewhere.
 */

"use client";

import {
  GetEmergencyDataQuery,
  GotoPassInfoLabelQuery,
} from "@/types/generated";
import { IOffer } from "./OfferBanner";
import Emmergency from "./Emergency";
import { useScrollThreshold } from "@/hooks/useScrollPosition";
import { HeaderType } from "@/utils/desingTemplateUtils";

export interface CriHeaderProps {
  offer?: IOffer;
  isShowGotoPass?: boolean | null;
  userInfo?: GotoPassInfoLabelQuery;
  emergency?: GetEmergencyDataQuery | null;
  locale: string;
  headerName?: HeaderType;
}

const CriHeader = ({
  emergency,
  locale,
  headerName,
}: CriHeaderProps) => {
  const isArtOrMspHeader = headerName === "art" || headerName === "msp";
  const isScrolled = useScrollThreshold();

  const { active, description, title, title_mobile, publishedAt } =
    emergency?.japanHotels?.[0]?.emergency || {};

  const showEmergency = Boolean(active) && (!isArtOrMspHeader || isScrolled);

  if (!showEmergency) return null;

  return (
    <Emmergency
      description={description}
      title={title}
      titleMobile={title_mobile}
      publishedAt={publishedAt}
      locale={locale}
      isCustomTemplate
    />
  );
};

export default CriHeader;
